import React, {Component} from 'react';
//import TestData from './data'
import TableFilter from '../TableFilter'
import DocumentiTable from './DocumentiTable'
import ErrorMessage from '../ErrorMessage'
import FileSaver from 'file-saver';
import {client} from '../../Client';
import {copiaTestoNegliAppunti, createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import TipoDocumentoComboFilter from "../TipoDocumentoComboFilter";

class DocumentiList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onChangeTipoDocumentoFilter = this.onChangeTipoDocumentoFilter.bind(this)
        this.loadData = this.loadData.bind(this)
        this.loadDocumentiPiuRecentiPerTipo = this.loadDocumentiPiuRecentiPerTipo.bind(this)
        this.onDownload = this.onDownload.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onUpload = this.onUpload.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            page: 1,
            itemsMostRecent:[],
            totalMostRecent: 0,
            orderInfo: {
                columnName: 'c.creatoIl',
                direction: 'D',
                data: [{field: 'c.creatoIl', direction: 'D'}]},
            filterInfo: {
                codiceTipoDocumento: '-1',
                nomeTipoDocumento: "Tutti i tipi di documento"
            },
            _loading: false,
            error: null
        };
    }

    componentDidMount() {

        if (this.storeInstance && this.storeInstance.restore('documentilist', this , () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }))
        {}
        else{
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
        this.loadDocumentiPiuRecentiPerTipo();
        // Segnalati comportamenti anomali. #5 BUG
        // if (this.storeInstance && this.storeInstance.restore('documentilist', this , () => {
        //         this.loadData(1,  this.state.orderInfo, this.state.filterInfo);
        //         this.loadDocumentiPiuRecentiPerTipo();
        //     }) === null){
        //     this.loadData(1,  this.state.orderInfo, this.state.filterInfo);
        //     this.loadDocumentiPiuRecentiPerTipo();
        // }
        // this.loadData(1,  this.state.orderInfo, this.state.filterInfo);
        // this.loadDocumentiPiuRecentiPerTipo();

    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('documentilist', this.state);
        }
        // Segnalati comportamenti anomali. #5 BUG
        // if (this.storeInstance) {
        //     this.storeInstance.save('documentilist', this.state);
        // }
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);}
        );
    }


    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    onChangeTipoDocumentoFilter(codice, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.codiceTipoDocumento = codice;
        filterInfo.nomeTipoDocumento = nome;
        this.loadData(1, this.state.orderInfo, filterInfo);
    }
    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(1, newOrderInfo, this.state.filterInfo)
    }

    onChangeFilter(data){
        let newFilterInfo = Object.assign(this.state.filterInfo, data);
        this.loadData(1, this.state.orderInfo, newFilterInfo)
    }

    onDownload(ev, documento){
        this.setState({_loading: true})
        client.downloadDocument(documento.idDocumento).then(
            (response) => {
                if (response.ok){
                    response.blob().then((blob) => {
                        this.setState({_loading: false, error: null})
                        FileSaver.saveAs(blob, documento.nome);
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    onDelete(ev, documento){
        this.setState({_loading: true});
        client.deleteDocumento(documento).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(1,this.state.orderInfo, this.state.filterInfo);
                this.loadDocumentiPiuRecentiPerTipo();
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onUpload(documento) {
        this.loadData(1, {field: 'creatoIl', direction: 'D'}, {keyword: documento.nome});
        this.loadDocumentiPiuRecentiPerTipo();
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadDocumentiList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    loadDocumentiPiuRecentiPerTipo() {
        this.setState({_loading: true});
        client.loadDocumentiPiuRecentiPerTipoList().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        itemsMostRecent: data.items,
                        totalMostRecent: data.items.length,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }
    render() {

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}} />)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let statsDocumenti = null;
        if (this.state.itemsMostRecent){

            statsDocumenti = (
                <div className="ui attached segment">
                    <div className="ui three column centered grid">
                        <div className="one wide column "></div>
                        <div className="fourteen wide column">
                <div className="ui tiny statistics">
                    {this.state.itemsMostRecent.map((item) => {

                        let copyBtn = null;
                        if (item.documento.clientFullname){
                            copyBtn = <a className="ui blue icon button" onClick={() => this.onCopyToClipboard(item.documento.clientFullname)} title="Copia il path locale del documento sugli appunti"><i
                                className="copy icon"
                            ></i></a>
                        }
                        else {
                            copyBtn = <a className="ui gray icon button disabled"  title="Path locale non impostato"><i
                                className="copy icon"
                            ></i></a>
                        }
                        let downloadBtn = (<a className="ui blue icon button" onClick={(ev) => (this.onDownload(ev, item.documento))}><i
                            className="download icon"

                        ></i></a>);

                        return (<div className="statistic">
                            <div className="value" title={item.nome_tipo_documento}>
                                {copyBtn} {downloadBtn} {item.codice_tipo_documento}
                            </div>
                            <div className="label">
                                {item.documento.nome}
                            </div>
                            <div className="label">
                                {item.creato_il}
                            </div>
                        </div>);
                    })}
                </div>
                        </div>
                        <div className="one wide column"></div>
                    </div>
                </div>
            );
        }

        return (<div className="ui">

            <h3 className="ui top block attached header">

                <div className="ui two column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Documenti soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">
                <div className="ui two column grid">
                    <div className="eight wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra documento per codice cartella, nome documento, commessa (codice e nome), divisione (nome e codice), data creazione..."
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="four wide column">
                        <TableFilter
                            showPopup={false}
                            value={this.state.filterInfo.anno}
                            valueName={"anno"}
                            placeholder="Anno"
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="four wide column">
                        <TipoDocumentoComboFilter
                            codice={this.state.filterInfo.codiceTipoDocumento}
                            abilitato={true}
                            onChange={this.onChangeTipoDocumentoFilter}
                        />
                    </div>
                </div>
            </div>
            {statsDocumenti}
            <div className="no-print">
            {/*<DocumentiUpload*/}
                {/*onUpload={this.onUpload}*/}
            {/*/>*/}
            </div>
            <DocumentiTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.rowperpage}
                tableOrderingField={this.state.orderInfo.columnName}
                tableOrderingDirection={this.state.orderInfo.direction}
                onChangePage={this.onChangePage}
                onChangeOrder={this.onChangeColumnOrder}
                onDownload={this.onDownload}
                onDelete={this.onDelete}
                readOnly={client.getCurrentUser().isroledocumentiw === false}
            />
            {loader}
        </div>)
    }
}

DocumentiList.contextTypes = {
    router: PropTypes.object
}

export default DocumentiList;




/** WEBPACK FOOTER **
 ** ./src/components/documenti/DocumentiList.js
 **/